// C1-INT - Ünite 3: Final Interview ve Panel
// Panel mülakat, video interview ve tam simülasyon

export const C1INT_UNIT_3 = {
  'C1INT-U3-L1': {
    id: 'C1INT-U3-L1',
    title: 'Panel Interview Stratejileri',
    type: 'theory',
    content: {
      sections: [
        {
          type: 'intro',
          title: '👥 Panel Mülakat Nedir?',
          content: 'Panel mülakatta 2-5 mülakatçı aynı anda sizi değerlendirir:\n• HR temsilcisi\n• Operations manager\n• Kıdemli kabin memuru/Purser\n• Bazen pilot temsilcisi\n\nHer biri farklı şeyler arar!'
        },
        {
          type: 'info',
          title: '🎯 Kim Ne Arar?',
          content: '**HR:** Kültürel uyum, motivasyon, kişilik\n**Operations:** Prosedür bilgisi, güvenlik farkındalığı\n**Kabin Ekibi:** Takım çalışması, hizmet anlayışı\n**Pilot:** CRM anlayışı, iletişim netliği'
        },
        {
          type: 'scenario',
          title: '✈️ Panel Mülakat Senaryosu',
          dialogues: [
            {
              speaker: 'HR (solda)',
              text: 'Good morning! I\'m Sarah from HR, this is Captain Ahmed from flight operations, and Maria who is a senior purser. We\'ll each ask you some questions today.',
              translation: 'Günaydın! Ben İK\'dan Sarah, bu Uçuş Operasyonlarından Kaptan Ahmed ve kıdemli kabin amiri Maria. Bugün her birimiz size bazı sorular soracağız.'
            },
            {
              speaker: 'Aday',
              text: 'Good morning Sarah, Captain Ahmed, Maria. Thank you for the opportunity to meet with you all today.',
              translation: 'Günaydın Sarah, Kaptan Ahmed, Maria. Bugün hepinizle görüşme fırsatı için teşekkür ederim.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Her birinin ismini kullanarak selamlama - isim hatırladığınızı gösterir',
              translation: ''
            },
            {
              speaker: 'Captain Ahmed',
              text: 'Let me start. Imagine during taxi, a passenger stands up to get something from the overhead bin. What do you do?',
              translation: 'Ben başlayayım. Taksi sırasında bir yolcunun üst dolaptan bir şey almak için ayağa kalktığını hayal edin. Ne yaparsınız?'
            },
            {
              speaker: 'Aday',
              text: 'Safety is the priority. I would immediately but calmly approach the passenger and say firmly: "Sir/Madam, I need you to take your seat right away - we\'re moving and it\'s not safe to stand." I\'d help them sit and fasten their seatbelt.',
              translation: 'Güvenlik öncelik. Hemen ama sakin bir şekilde yolcuya yaklaşır ve kararlılıkla söylerdim: "Efendim, hemen yerinize oturmanız gerekiyor - hareket ediyoruz ve ayakta durmak güvenli değil." Oturup emniyet kemerini bağlamasına yardım ederdim.'
            },
            {
              speaker: 'Captain Ahmed (memnun)',
              text: 'Good. And if they resist?',
              translation: 'İyi. Ya direnirse?'
            },
            {
              speaker: 'Aday',
              text: 'I\'d stay calm but firm, explaining the safety reason clearly: "For your safety and everyone\'s, regulations require you to be seated during taxi." If they still refused, I\'d inform the purser immediately and if necessary, we\'d notify the flight deck before takeoff.',
              translation: 'Sakin ama kararlı kalır, güvenlik nedenini açıkça açıklardım: "Sizin ve herkesin güvenliği için, düzenlemeler taksi sırasında oturmanızı gerektiriyor." Hâlâ reddederlerse, hemen kabin amirini bilgilendirir ve gerekirse kalkıştan önce kokpiti haberdar ederdik.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Kaptan sorusu = güvenlik odaklı, prosedür bilgisi ve kararlılık gösterin',
              translation: ''
            },
            {
              speaker: 'Maria (Purser)',
              text: 'Now my turn. You\'ve been serving for hours and you\'re exhausted. A passenger asks for something outside normal service. How do you respond?',
              translation: 'Şimdi benim sıram. Saatlerdir servis yapıyorsunuz ve tükenmiş durumdasınız. Bir yolcu normal servis dışında bir şey istiyor. Nasıl cevap verirsiniz?'
            },
            {
              speaker: 'Aday',
              text: 'Honestly, fatigue is part of this job, and I\'d never let it show to a passenger. I\'d listen to their request with genuine interest. If it\'s something I can reasonably accommodate, I\'d do my best. If it\'s not possible, I\'d explain kindly and offer an alternative.',
              translation: 'Dürüst olmak gerekirse, yorgunluk bu işin bir parçası ve bunu asla yolcuya göstermem. İsteklerini gerçek ilgiyle dinlerdim. Makul şekilde karşılayabileceğim bir şeyse, elimden geleni yapardım. Mümkün değilse, nazikçe açıklar ve alternatif sunardım.'
            },
            {
              speaker: 'Maria (devam)',
              text: 'Can you give an example of a creative solution?',
              translation: 'Yaratıcı bir çözüm örneği verebilir misiniz?'
            },
            {
              speaker: 'Aday',
              text: 'Once a guest asked for a specific tea brand we didn\'t carry. I couldn\'t provide that exact brand, but I found a similar herbal option and presented it on a nice tray with some cookies, explaining it was our closest match. The guest was delighted by the effort.',
              translation: 'Bir keresinde bir misafir bizde olmayan belirli bir çay markası istedi. Tam o markayı sağlayamasam da, benzer bir bitkisel seçenek buldum ve en yakın eşleşmemiz olduğunu açıklayarak güzel bir tepside birkaç kurabiyeyle sundum. Misafir gösterilen çabadan çok memnun kaldı.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Purser sorusu = hizmet kalitesi, yaratıcılık ve pozitif tutum gösterin',
              translation: ''
            },
            {
              speaker: 'Sarah (HR)',
              text: 'Final question from me. Where do you see yourself in five years?',
              translation: 'Benden son soru. Beş yıl sonra kendinizi nerede görüyorsunuz?'
            },
            {
              speaker: 'Aday',
              text: 'In five years, I hope to have grown significantly within this airline. Initially, I want to master the cabin crew role and become someone my colleagues can rely on. Eventually, I\'d love to take on more responsibility—perhaps as a purser—where I can mentor newer crew members and contribute to training programs.',
              translation: 'Beş yıl içinde bu havayolunda önemli ölçüde büyümüş olmayı umuyorum. Başlangıçta, kabin memurluğu rolünde ustalaşmak ve meslektaşlarımın güvenebileceği biri olmak istiyorum. Sonunda, daha fazla sorumluluk almayı çok isterim—belki kabin amiri olarak—yeni ekip üyelerine mentorluk yapabileceğim ve eğitim programlarına katkıda bulunabileceğim.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ HR sorusu = şirket içinde büyüme vizyonu, bağlılık gösterin',
              translation: ''
            }
          ]
        },
        {
          type: 'framework',
          title: '📋 Panel Mülakat Altın Kuralları',
          content: '1. **Göz teması:** Soruyu sorana başla, cevap verirken herkese dağıt\n2. **İsim kullanımı:** Her panelisti ismiyele hitap et\n3. **Not alma:** Gerekirse küçük not defteri kullanabilirsin\n4. **Sessiz olanı unutma:** En az konuşan kişi genellikle karar verici\n5. **Farklı cevaplar:** HR\'a farklı, pilota farklı tonda cevap ver\n6. **Takip soruları:** Panel sıkça takip sorusu sorar, hazır ol'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Panel mülakatında göz teması:',
          options: [
            'Sadece soruyu sorana bak',
            'Soruyu soranla başla, tüm panele dağıt',
            'Masaya bak',
            'Sadece HR\'a bak'
          ],
          correctIndex: 1,
          explanation: 'Soruyu soranla başlayıp tüm paneli dahil etmek profesyonellik gösterir.'
        }
      ]
    }
  },

  'C1INT-U3-L2': {
    id: 'C1INT-U3-L2',
    title: 'Video Interview Tips',
    type: 'theory',
    content: {
      sections: [
        {
          type: 'intro',
          title: '📹 Video Mülakat Trendi',
          content: 'Birçok havayolu artık ön eleme için video mülakat kullanıyor:\n• **HireVue:** Emirates, American Airlines\n• **Sonru:** British Airways, Etihad\n• **Canlı Zoom/Teams:** İlk turlar\n\nVideo mülakatın kendine özgü zorlukları var.'
        },
        {
          type: 'info',
          title: '📹 Video Mülakat Türleri',
          content: '**1. Önceden Kayıtlı (Asenkron):**\n• Sorular ekranda belirir\n• Hazırlık süresi (genellikle 30-60 saniye)\n• Kayıt süresi (genellikle 1-3 dakika)\n• Tek şans - tekrar kayıt yok\n\n**2. Canlı Video:**\n• Zoom/Teams üzerinden\n• Gerçek zamanlı etkileşim\n• Teknik sorunlara hazırlıklı ol'
        },
        {
          type: 'checklist',
          title: '✅ Video Mülakat Hazırlık Listesi',
          content: '**Teknik:**\n□ İnternet hızını test et\n□ Kamerayı göz hizasına ayarla\n□ Sessiz ortam seç\n□ Yedek cihaz hazır tut\n□ Platform\'u önceden test et\n\n**Görsel:**\n□ Düz, nötr arka plan\n□ Doğal aydınlatma (pencere önünde DEĞİL, arkasında)\n□ Profesyonel kıyafet (tam set, sadece üst değil)\n□ Minimal takı ve makyaj\n\n**Performans:**\n□ Kameraya bak, ekrana değil\n□ Yavaş ve net konuş\n□ El hareketleri minimumda\n□ Gülümse - kamerada daha az görünür'
        },
        {
          type: 'scenario',
          title: '✈️ Video Mülakat Senaryosu: Önceden Kayıtlı',
          dialogues: [
            {
              speaker: 'Ekran',
              text: 'Question 1: Why do you want to become a cabin crew member? You have 30 seconds to prepare and 2 minutes to respond.',
              translation: 'Soru 1: Neden kabin memuru olmak istiyorsunuz? 30 saniye hazırlık ve 2 dakika cevap süreniz var.'
            },
            {
              speaker: 'Aday (iç ses - hazırlık)',
              text: '(Okay, 30 seconds. I\'ll structure: passion + relevant experience + why this airline. Take a breath.)',
              translation: '(Tamam, 30 saniye. Yapılandırayım: tutku + ilgili deneyim + neden bu havayolu. Bir nefes al.)'
            },
            {
              speaker: '🔴 Kayıt Başladı',
              text: '',
              translation: ''
            },
            {
              speaker: 'Aday',
              text: 'I want to become cabin crew because I\'m genuinely passionate about combining travel with service. For three years in hospitality, I\'ve discovered that making people feel cared for—especially when they\'re far from home—is incredibly rewarding.',
              translation: 'Kabin memuru olmak istiyorum çünkü seyahati hizmetle birleştirme konusunda gerçekten tutkuluyum. Üç yıl konaklamada, insanların—özellikle evlerinden uzaktayken—ilgilenildiğini hissettirmenin inanılmaz tatmin edici olduğunu keşfettim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Flying takes that to another level—you\'re with passengers during a vulnerable time, and small gestures of warmth can transform their journey. I want to be that reassuring presence at 35,000 feet.',
              translation: 'Uçmak bunu başka bir seviyeye taşıyor—savunmasız bir zamanda yolcularla birliktesiniz ve küçük sıcaklık jestleri yolculuklarını dönüştürebilir. 35.000 feet\'te o rahatlatıcı varlık olmak istiyorum.'
            },
            {
              speaker: '🔴 Kayıt Bitti',
              text: '',
              translation: ''
            }
          ]
        },
        {
          type: 'warning',
          title: '❌ Video Mülakatın Yaygın Hataları',
          content: '• **Göz teması:** Ekrana değil, kameraya bak\n• **Arka plan:** Dağınık oda, hareket eden insanlar\n• **Ses:** Eko, arka plan gürültüsü\n• **Işık:** Yüz karanlık, arka plan parlak\n• **Kıyafet:** Sadece üst profesyonel (ayağa kalkarsan?)\n• **Okuma:** Notlardan okumak belli oluyor\n• **Hız:** Çok hızlı veya monoton konuşma'
        },
        {
          type: 'tip',
          content: '💡 **Pro İpucu - Kamera Hilesi:**\nKameranın hemen yanına küçük bir gülen yüz yapıştırın. Kameraya bakmak yerine ona bakın - doğal gülümseme oluşturur ve göz temasını hatırlatır.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Video mülakatında göz teması için:',
          options: [
            'Ekrandaki mülakatçıya bak',
            'Kameraya bak',
            'Notlarına bak',
            'Etrafına bak'
          ],
          correctIndex: 1,
          explanation: 'Kameraya bakmak, izleyici için göz teması yaratır. Ekrana bakmak kaçamak görünür.'
        }
      ]
    }
  },

  'C1INT-U3-L3': {
    id: 'C1INT-U3-L3',
    title: 'Final Round Hazırlık',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🏁 Final Turuna Hoş Geldiniz!',
          content: 'Final turuna kaldıysanız, teknik olarak yeterliliğiniz kanıtlanmış demek. Artık değerlendirilen:\n\n• Kültürel uyum\n• Uzun vadeli potansiyel\n• "Bu kişiyle 14 saat uçmak ister miyim?" testi'
        },
        {
          type: 'info',
          title: '🎯 Final Turunda Farklı Olan',
          content: '**Genellikle:**\n• Daha kıdemli yöneticiler\n• Daha kişisel sorular\n• Daha az "standart" soru, daha fazla konuşma\n• Belki bir öğle yemeği veya kahve (değerlendirme devam ediyor!)\n• Sorularınıza daha fazla zaman\n\n**Değerlendirilen:**\n• Otantiklik - sahte mi, gerçek mi?\n• Kültürel uyum - takıma uyar mı?\n• İletişim tarzı - rahat mı, gergin mi?\n• Potansiyel - 5 yıl sonra nerede olur?'
        },
        {
          type: 'scenario',
          title: '✈️ Final Turu Senaryosu',
          dialogues: [
            {
              speaker: 'Kıdemli Yönetici',
              text: 'You\'ve made it to the final round—congratulations. At this point, I just want to get to know you better. Tell me, what do you do for fun outside of work?',
              translation: 'Final turuna kaldınız—tebrikler. Bu noktada, sadece sizi daha iyi tanımak istiyorum. Söyleyin, iş dışında eğlence için ne yaparsınız?'
            },
            {
              speaker: 'Aday',
              text: 'Thank you! Outside work, I\'m an avid reader—mostly non-fiction about psychology and travel. I also enjoy cooking dishes from different cuisines. Last month I attempted Korean kimchi from scratch, which was an adventure!',
              translation: 'Teşekkür ederim! İş dışında, hevesli bir okurüm—çoğunlukla psikoloji ve seyahat hakkında kurgu dışı. Ayrıca farklı mutfaklardan yemekler yapmaktan zevk alıyorum. Geçen ay sıfırdan Kore kimchisi denedim, bir maceraydı!'
            },
            {
              speaker: 'Kıdemli Yönetici (gülümsüyor)',
              text: 'Korean food! Have you been to Seoul?',
              translation: 'Kore yemeği! Seul\'e gittiniz mi?'
            },
            {
              speaker: 'Aday',
              text: 'Not yet, but it\'s high on my list! That\'s part of what draws me to this career—the opportunity to experience cultures firsthand. I\'d love to taste authentic kimchi in Korea someday.',
              translation: 'Henüz değil, ama listemin üstlerinde! Bu kariyer beni çeken şeyin bir parçası—kültürleri ilk elden deneyimleme fırsatı. Bir gün Kore\'de otantik kimchi tatmayı çok isterim.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Rahat ol, özgün ol, ama her şeyi işe bağlama potansiyeline dikkat et',
              translation: ''
            },
            {
              speaker: 'Kıdemli Yönetici',
              text: 'Now, I have to ask—is there anything about this role that concerns you? Anything you\'re uncertain about?',
              translation: 'Şimdi sormam lazım—bu rol hakkında sizi endişelendiren bir şey var mı? Belirsiz olduğunuz bir şey?'
            },
            {
              speaker: 'Aday (dürüst ama pozitif)',
              text: 'Honestly, the irregular schedule is something I\'ve thought about carefully. I know it can be challenging—missing holidays, adjusting sleep patterns. But I\'ve spoken with current cabin crew, and they say you adapt. And for me, the trade-off of experiencing the world is worth it.',
              translation: 'Dürüst olmak gerekirse, düzensiz program dikkatlice düşündüğüm bir şey. Zorlu olabileceğini biliyorum—tatilleri kaçırmak, uyku düzenini ayarlamak. Ama mevcut kabin ekibiyle konuştum ve adapte olduğunuzu söylüyorlar. Ve benim için, dünyayı deneyimlemenin karşılığı buna değer.'
            },
            {
              speaker: 'Kıdemli Yönetici',
              text: 'I appreciate your honesty. One last thing—do you have any questions for me?',
              translation: 'Dürüstlüğünüzü takdir ediyorum. Son bir şey—bana sorunuz var mı?'
            },
            {
              speaker: 'Aday',
              text: 'Yes, I\'d love to know—what do you personally find most rewarding about working here after all these years?',
              translation: 'Evet, bilmek isterdim—bunca yıldan sonra burada çalışmanın sizin için kişisel olarak en ödüllendirici yanı ne?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Kişisel soru sormak bağ kurar ve gerçek ilgi gösterir',
              translation: ''
            }
          ]
        },
        {
          type: 'framework',
          title: '📋 Final Turu Soru Hazırlığı',
          content: '**Sizin İçin Hazırlanan Sorular:**\n• "Bu rol hakkında endişelendiğiniz bir şey var mı?"\n• "Aileniz/partneriniz bu kariyer hakkında ne düşünüyor?"\n• "Başka nereye başvurdunuz?"\n• "Neden sizi diğer adaylardan seçelim?"\n• "5 yıl sonra kendinizi nerede görüyorsunuz?"\n\n**Sizin Soracağınız Sorular:**\n• "Sizce bu rolde başarılı olanların ortak özelliği ne?"\n• "Şirket kültürünü üç kelimeyle nasıl tanımlarsınız?"\n• "Eğitim sürecinde en zorlu kısım ne?"\n• "En çok gurur duyduğunuz şirket gelişmesi ne?"'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Final turunda "Bu rol hakkında endişeniz var mı?" sorusuna:',
          options: [
            '"Hiç endişem yok, her şey mükemmel"',
            'Dürüst bir endişe + nasıl üstesinden geleceğinizi açıklayın',
            '"Maaş konusunda endişeliyim"',
            '"Zorlukları sevmiyorum"'
          ],
          correctIndex: 1,
          explanation: 'Dürüstlük + çözüm odaklı yaklaşım olgunluk gösterir. "Hiç endişem yok" samimiyetsiz görünür.'
        }
      ]
    }
  },

  'C1INT-U3-L4': {
    id: 'C1INT-U3-L4',
    title: 'Tam Mülakat Simülasyonu',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 45 Dakikalık Tam Mülakat',
          content: 'Bu ders, gerçek bir havayolu mülakatının tam simülasyonudur. Emirates assessment day formatında hazırlanmıştır.'
        },
        {
          type: 'scenario',
          title: '✈️ EMIRATES FINAL INTERVIEW',
          dialogues: [
            {
              speaker: 'Ortam',
              text: 'Dubai, Emirates Group Headquarters. Conference room with 3 interviewers.',
              translation: 'Dubai, Emirates Grup Merkezi. 3 mülakatçılı konferans odası.'
            },
            {
              speaker: 'Panel',
              text: 'Good morning! Please have a seat. I\'m James, this is Fatima from cabin services, and Omar from recruitment. We\'ve reviewed your application and were impressed. Let\'s begin.',
              translation: 'Günaydın! Lütfen oturun. Ben James, bu kabin hizmetlerinden Fatima ve işe alımdan Omar. Başvurunuzu inceledik ve etkilendik. Başlayalım.'
            },
            {
              speaker: 'Aday',
              text: 'Good morning James, Fatima, Omar. Thank you for this opportunity. I\'m excited to be here.',
              translation: 'Günaydın James, Fatima, Omar. Bu fırsat için teşekkür ederim. Burada olmaktan heyecan duyuyorum.'
            },
            {
              speaker: 'James (HR)',
              text: 'Let\'s start simple. Walk us through your background and what brings you to Emirates today.',
              translation: 'Basit başlayalım. Geçmişinizi ve bugün sizi Emirates\'e ne getirdiğini anlatın.'
            },
            {
              speaker: 'Aday',
              text: 'Certainly. I\'m originally from Turkey, where I completed my degree in Tourism Management. For the past three years, I\'ve worked in luxury hospitality—first at a boutique hotel in Istanbul, then at a five-star resort in Antalya.',
              translation: 'Tabii. Aslında Türkiye\'denim, Turizm Yönetimi diplomamı orada tamamladım. Son üç yıldır lüks konaklamada çalıştım—önce İstanbul\'da bir butik otelde, sonra Antalya\'da beş yıldızlı bir tatil köyünde.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'What brings me to Emirates specifically is your reputation for excellence. I\'ve always been fascinated by aviation, and Emirates represents the gold standard. The idea of combining my hospitality skills with the adventure of flying—while living in Dubai—feels like the natural next step in my career.',
              translation: 'Özellikle beni Emirates\'e getiren şey mükemmellik itibarınız. Her zaman havacılıktan etkilenmişimdir ve Emirates altın standardı temsil ediyor. Konaklama becerilerimi uçma macerası ile birleştirme fikri—Dubai\'de yaşarken—kariyerimde doğal bir sonraki adım gibi geliyor.'
            },
            {
              speaker: 'Fatima (Cabin Services)',
              text: 'You mentioned luxury hospitality. Tell me about a time when you had to handle a very demanding guest.',
              translation: 'Lüks konaklamadan bahsettiniz. Çok talepkâr bir misafirle ilgilenmeniz gereken bir zamanı anlatın.'
            },
            {
              speaker: 'Aday',
              text: 'Yes, I remember one situation clearly. We had a guest who had booked our honeymoon suite for his anniversary. When he arrived, he discovered a minor issue with the room—a small mark on the bathroom mirror. He became extremely upset, saying his whole trip was ruined.',
              translation: 'Evet, bir durumu net hatırlıyorum. Yıldönümü için balayı süitimizi rezerve etmiş bir misafirimiz vardı. Geldiğinde, odada küçük bir sorun keşfetti—banyo aynasında küçük bir leke. Son derece üzüldü, tüm gezisinin mahvolduğunu söyledi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Instead of getting defensive, I listened completely. I realized this wasn\'t really about the mirror—it was about the pressure he felt to make everything perfect for his wife. I apologized sincerely, immediately had the mirror replaced, and arranged for champagne and flowers in the room with a handwritten note.',
              translation: 'Savunmacı olmak yerine, tamamen dinledim. Bunun gerçekten aynayla ilgili olmadığını fark ettim—karısı için her şeyi mükemmel yapma konusunda hissettiği baskıyla ilgiliydi. İçtenlikle özür diledim, hemen aynayı değiştirdim ve odaya el yazısı bir notla şampanya ve çiçek ayarladım.'
            },
            {
              speaker: 'Fatima',
              text: 'What was the outcome?',
              translation: 'Sonuç ne oldu?'
            },
            {
              speaker: 'Aday',
              text: 'He actually came to thank me personally the next day. He said no one had ever taken his concerns so seriously. He became a regular guest and even referred his friends. What I learned is that upset guests often just want to feel heard.',
              translation: 'Aslında ertesi gün kişisel olarak teşekkür etmeye geldi. Hiç kimsenin endişelerini bu kadar ciddiye almadığını söyledi. Düzenli misafir oldu ve hatta arkadaşlarını da yönlendirdi. Öğrendiğim şey, üzgün misafirlerin genellikle sadece duyulmak istedikleri.'
            },
            {
              speaker: 'Omar (Recruitment)',
              text: 'Good example. Now, a scenario question. You\'re on a 14-hour flight. It\'s hour 10, service is done, and you\'re exhausted. A passenger approaches and says their seat won\'t recline and they can\'t sleep. What do you do?',
              translation: 'Güzel örnek. Şimdi, bir senaryo sorusu. 14 saatlik bir uçuştasınız. 10. saat, servis bitti ve tükenmiş durumdasınız. Bir yolcu yaklaşıyor ve koltuğunun yatmadığını ve uyuyamadığını söylüyor. Ne yaparsınız?'
            },
            {
              speaker: 'Aday',
              text: 'First, I\'d never show my fatigue—the passenger\'s experience matters regardless of how I feel. I\'d approach with empathy: "I\'m sorry to hear that. Let me see what I can do."',
              translation: 'Önce asla yorgunluğumu göstermezdim—nasıl hissetsem de yolcunun deneyimi önemli. Empatiyle yaklaşırdım: "Bunu duyduğuma üzüldüm. Ne yapabileceğime bakayım."'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I\'d check the seat mechanism myself. If it\'s a technical issue I can\'t fix, I\'d check if any other seats are available and offer to move them. If no seats are free, I\'d offer extra pillows and blankets to maximize their comfort, and perhaps a hot drink to help them relax.',
              translation: 'Koltuk mekanizmasını kendim kontrol ederdim. Düzeltemeyeceğim teknik bir sorunsa, başka koltuk olup olmadığını kontrol eder ve taşınmayı teklif ederdim. Boş koltuk yoksa, konforlarını en üst düzeye çıkarmak için ekstra yastık ve battaniye ve belki gevşemelerine yardımcı olmak için sıcak bir içecek sunardım.'
            },
            {
              speaker: 'Omar',
              text: 'And if they\'re still not satisfied?',
              translation: 'Ya hâlâ memnun değillerse?'
            },
            {
              speaker: 'Aday',
              text: 'I\'d log the issue so they can receive appropriate compensation after the flight—perhaps miles or a voucher. I\'d also apologize genuinely and check on them later in the flight. Sometimes knowing someone cares makes a difference, even if the problem can\'t be fully solved.',
              translation: 'Uçuştan sonra uygun tazminat alabilmeleri için sorunu kaydederdim—belki miller veya bir kupon. Ayrıca içtenlikle özür diler ve uçuşta daha sonra kontrol ederdim. Bazen sorun tamamen çözülemese bile, birinin umursadığını bilmek fark yaratır.'
            },
            {
              speaker: 'James',
              text: 'Final question. Why should we choose you over other candidates?',
              translation: 'Son soru. Sizi diğer adaylar yerine neden seçmeliyiz?'
            },
            {
              speaker: 'Aday',
              text: 'I believe what sets me apart is my combination of genuine service passion and cultural adaptability. I\'ve worked with guests from over 40 countries, and I\'ve learned to read different communication styles and needs.',
              translation: 'Beni farklı kılanın gerçek hizmet tutkusu ve kültürel uyum yeteneğimin birleşimi olduğuna inanıyorum. 40\'tan fazla ülkeden misafirlerle çalıştım ve farklı iletişim stillerini ve ihtiyaçları okumayı öğrendim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'More importantly, I don\'t just want a cabin crew job—I want an Emirates career. I\'ve researched your training program, your growth opportunities, and I\'m ready to invest myself fully. I believe service excellence isn\'t a skill you learn once—it\'s a mindset you practice every day. And that\'s how I live.',
              translation: 'Daha da önemlisi, sadece bir kabin memurluğu işi istemiyorum—Emirates kariyeri istiyorum. Eğitim programınızı, büyüme fırsatlarınızı araştırdım ve kendimi tamamen yatırmaya hazırım. Hizmet mükemmelliğinin bir kez öğrenilen bir beceri olmadığına inanıyorum—her gün pratik ettiğiniz bir zihniyet. Ve ben böyle yaşıyorum.'
            },
            {
              speaker: 'Panel',
              text: 'Thank you. We\'ll be in touch within two weeks. Do you have any questions for us?',
              translation: 'Teşekkür ederiz. İki hafta içinde sizinle iletişime geçeceğiz. Bize sorunuz var mı?'
            },
            {
              speaker: 'Aday',
              text: 'Yes, I\'d love to ask—what do you find most rewarding about working for Emirates? I\'ve read the official materials, but I\'d love to hear your personal perspective.',
              translation: 'Evet, sormak isterdim—Emirates için çalışmanın sizin için en ödüllendirici yanı ne? Resmi materyalleri okudum ama kişisel bakış açınızı duymak isterim.'
            },
            {
              speaker: 'Fatima (gülümsüyor)',
              text: 'After 12 years, it\'s still the moments of genuine connection. Last week, a passenger came up to thank me for helping calm her anxious son on his first flight. Those moments make everything worth it.',
              translation: '12 yıl sonra, hâlâ gerçek bağlantı anları. Geçen hafta bir yolcu ilk uçuşunda endişeli oğlunu sakinleştirmeye yardım ettiğim için teşekkür etmeye geldi. Bu anlar her şeye değiyor.'
            },
            {
              speaker: 'Aday',
              text: 'That\'s exactly why I want this. Thank you all for your time today.',
              translation: 'Tam da bu yüzden istiyorum. Bugünkü zamanınız için hepinize teşekkür ederim.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Simülasyon Analizi',
          content: '**✅ Adayın Güçlü Yönleri:**\n• Her panelisti ismiyle selamlama\n• STAR metodunu doğal kullanım\n• Empati odaklı hikayeler\n• Dürüstlük (yorgunluk konusu)\n• Şirket araştırması belli\n• Kariyer odaklı (iş değil, kariyer)\n• Kişisel soru sorma (bağ kurma)\n\n**🎯 Anahtar Mesajlar:**\n• "What brings me to Emirates specifically..."\n• "I don\'t just want a job—I want a career"\n• "Service excellence is a mindset you practice every day"'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Bu simülasyonda adayın en güçlü yanı:',
          options: [
            'Çok uzun cevaplar vermesi',
            'Her cevapta empati ve somut örnekler sunması',
            'Sadece kendinden bahsetmesi',
            'Paneli eleştirmesi'
          ],
          correctIndex: 1,
          explanation: 'Her cevap empati, somut örnek ve havayoluyla bağlantı içeriyor.'
        }
      ]
    }
  },

  'C1INT-U3-EXAM': {
    id: 'C1INT-U3-EXAM',
    title: 'C1 Interview Final Exam',
    type: 'final_exam',
    content: {
      timeLimit: 50,
      passingScore: 75,
      questions: [
        {
          type: 'multipleChoice',
          question: 'In a panel interview, how should you maintain eye contact?',
          options: [
            'Only look at the person asking the question',
            'Start with the questioner, then distribute to the entire panel',
            'Look at the table',
            'Close your eyes'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Why is placing a smiley face next to your camera in a video interview helpful?',
          options: [
            'It\'s silly',
            'It reminds you to look at the camera and helps you smile naturally',
            'It\'s unprofessional',
            'It\'s unnecessary'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'How should you answer "Do you have any concerns about this role?" in a final round?',
          options: [
            '"I have no concerns at all"',
            'Be honest about a concern + explain how you will overcome it',
            '"My concern is the salary"',
            '"I don\'t like difficult work"'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In the STAR method, what should the "R" (Result) section contain?',
          options: [
            'Explain the problem again',
            'Measurable outcome and lasting impact',
            'Blame others',
            'Skip the question'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What does the phrase "I don\'t just want a job—I want a career" demonstrate?',
          options: [
            'Salary negotiation',
            'Long-term commitment and growth vision',
            'Wanting to become a manager immediately',
            'Applying to other companies'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In a panel interview, what should you know about the quietest person?',
          options: [
            'They are unimportant',
            'They are often the decision maker',
            'They are sleeping',
            'They are useless'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What is the BEST question to ask at the end of an interview?',
          options: [
            '"How much is the salary?"',
            '"What qualities do successful people in this role have in common?"',
            '"How many vacation days do I get?"',
            '"When does this end?"'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In airline interviews, what does "servant leadership" mean?',
          options: [
            'Being a servant',
            'A leader who serves, supports, and develops the team',
            'Being at everyone\'s command',
            'Not leading at all'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is the WORST answer to "Tell me about a failure"?',
          options: [
            'A real mistake + what you learned',
            '"I have never experienced failure"',
            'A work example + changes you made',
            'Taking responsibility'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In an Emirates interview, what should you emphasize?',
          options: [
            'Only salary',
            'Passion for excellence + multicultural experience + career growth',
            'Short-term work',
            'Only travel'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default C1INT_UNIT_3;
